module.exports = __webpack_public_path__ + "static/img/content-bg.4b80ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-bg.jpg
// module id = TMzu
// module chunks = 1